import { AlertOctagon } from "lucide-react";
import { Link, useRouteError, isRouteErrorResponse } from "react-router-dom";

import { Button } from "@/components/ui/button";

export function ErrorPage() {
  const error = useRouteError();

  let title = "Algo deu errado";
  let detail = "Erro inesperado.";

  if (isRouteErrorResponse(error)) {
    title = `${error.status} ${error.statusText}`;
    detail = error.data?.message ?? "Página não encontrada.";
  } else if (error instanceof Error) {
    detail = error.message;
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center space-y-4">
        <AlertOctagon className="h-12 w-12 text-destructive-600 mx-auto" aria-hidden />
        <h1 className="font-sans text-3xl font-bold">{title}</h1>
        <p className="text-muted-foreground">{detail}</p>
        <Button asChild>
          <Link to="/">Voltar para o início</Link>
        </Button>
      </div>
    </div>
  );
}
